/** Contains the top bar used within the chat pages */

import * as preact from "preact";

import * as modalDialog from "modalDialog";
import models from "models/models";
import DropdownMenu from "views/DropdownMenu";
import StreakView from "views/StreakView";
import TTSVoicePickerView from "views/TTSVoicePickerView";
import * as browserTTSVoices from "../browserTTSVoices";

interface Props {
  progress?: number; // Number from 0 to 1
  language?: string;
  onClose: () => void;
  ttsVoices: { voiceURI: string; displayName: string }[];
  children: preact.ComponentChildren;
}

interface State {}

export class ChatContainerView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      // Initialize your state here
    };

    browserTTSVoices.onChange(this.ttsVoiceChangeHandler);
  }

  ttsVoiceChangeHandler = () => {
    this.forceUpdate();
  };

  render() {
    const voiceURI = browserTTSVoices.getVoice(this.props.language);
    const voiceDisplayName = this.props.ttsVoices.find(
      (voice) => voice.voiceURI === voiceURI
    )?.displayName;

    return (
      <div class="chatColumn">
        <div class="headerContainer">
          <div class="header">
            <div class="chatCloseButton" onClick={this.props.onClose}>
              <i class="icon icon-remove"></i>
            </div>
            {this.props.progress === undefined ? (
              <div class="headerTitle">Conversations</div>
            ) : (
              <div class="practiceProgressBarContainer">
                <div
                  class="progressBar"
                  style={{
                    width: `${Math.round(this.props.progress * 100)}%`,
                    height: 20,
                    borderRadius: 10,
                  }}
                ></div>
              </div>
            )}
            <StreakView model={models.streak} hideUponCompletion={false} />
            <DropdownMenu
              items={[
                {
                  type: "toggle",
                  label: "Speaking mode",
                  initialValue: models.user.get("speakingMode"),
                  onToggle: (value) => {
                    models.user.save({ speakingMode: value }, { patch: true });
                  },
                },
                ...(this.props.ttsVoices.length > 0 && this.props.language
                  ? [
                      {
                        type: "action" as const,
                        label: voiceDisplayName
                          ? `Voice: ${voiceDisplayName}`
                          : "Select Voice",
                        onClick: () => {
                          modalDialog.showPreactComponent(
                            <TTSVoicePickerView
                              title="Pick a voice for Ami"
                              ttsVoices={this.props.ttsVoices}
                              language={this.props.language}
                              close={() => {
                                modalDialog.cancelAll();
                              }}
                            />
                          );
                        },
                      },
                    ]
                  : []),
              ]}
            />
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }

  componentWillUnmount(): void {
    browserTTSVoices.offChange(this.ttsVoiceChangeHandler);
  }
}

export default ChatContainerView;
